import React from "react";
import { Link } from "react-router-dom";
import {
  IndustrySolutions1,
  IndustrySolutions2,
  IndustrySolutions3,
} from "./data";
const IndustrySolutions = () => {
  return (
    <div className="menu-right-content">
      <ul className="tabpanel-column1">
        {IndustrySolutions1.map((list) => {
          return (
            <Link to={list.path}>
              <li>
                <div>
                  <div className="circle">
                    <div className="sub-icon">{list.icon}</div>
                  </div>
                </div>
                <div className="content">
                  <h5>{list.title}</h5>
                  <p>{list.desc}</p>
                </div>
              </li>
            </Link>
          );
        })}
      </ul>
      <ul className="tabpanel-column2">
        {IndustrySolutions2.map((list) => {
          return (
            <Link to={list.path}>
              <li>
                <div>
                  <div className="circle">
                    <div className="sub-icon">{list.icon}</div>
                  </div>
                </div>
                <div className="content">
                  <h5>{list.title}</h5>
                  <p>{list.desc}</p>
                </div>
              </li>
            </Link>
          );
        })}
      </ul>
      <ul className="tabpanel-column3">
        {IndustrySolutions3.map((list) => {
          return (
            <Link to={list.path}>
              <li>
                <div>
                  <div className="circle">
                    <div className="sub-icon">{list.icon}</div>
                  </div>
                </div>
                <div className="content">
                  <h5>{list.title}</h5>
                  <p>{list.desc}</p>
                </div>
              </li>
            </Link>
          );
        })}
      </ul>
    </div>
  );
};

export default IndustrySolutions;
